import { isEnterpriseTier, isFreeTier } from '../../shared/subscriptions';
import { window } from '../globals';

/**
 * Check if the currently logged in user is in an org in a plan that is in the free tier.
 *
 * @returns True if there's an org for the logged in user and that org is in a plan
 * that is in the free tier.
 */
export function isOrgInFreeTier(): boolean {
  if (!window?.user?.organization) {
    return false;
  }

  const org = window.user.organization;
  return isFreeTier({ plan: org.stripe_plan, stripePriceLimit: org.stripePriceLimit });
}

export function isOrgInEnterpriseTier(): boolean {
  if (!window?.user?.organization) {
    return false;
  }

  const org = window.user.organization;
  return isEnterpriseTier({ plan: org.stripe_plan, stripePriceLimit: org.stripePriceLimit });
}
